import { transformMenuDetailToTabsConfig } from './transformMenuDetail';

export const buildFormValues = (role, menuDetailsData) => {
  if (!role) return {};

  const values = {
    roleName: role.name,
    description: role.description,
    status: role.isActive ? 'active' : 'inactive',
    roleType: role.roleType,
  };

  const tabs = transformMenuDetailToTabsConfig(menuDetailsData || []);

  (menuDetailsData || []).forEach((menu) => {
    values[`menu_${menu.id}`] = menu.isSelected === true;
  });

  tabs.forEach((tab) => {
    tab.subMenus?.forEach((sub) => {
      const allSelected = sub.permissions?.length && sub.permissions.every((p) => p.isSelected);
      values[`menu_${tab.id}_${sub.id}_enable_all`] = allSelected;

      sub.permissions?.forEach((perm) => {
        values[`menu_${tab.id}_${sub.id}_${perm.id}`] = perm.isSelected;
      });
    });
  });

  return values;
};

export const buildRolePayload = (data) => {
  const menuIds = Object.entries(data)
    .filter(([key, value]) => value && key.startsWith('menu_') && key.split('_').length === 2)
    .map(([key]) => Number(key.replace('menu_', '')));

  return {
    roleName: data.roleName,
    description: data.description,
    isActive: data.status === 'active',
    roleType: data.roleType,
    menuIds,
  };
};

export const buildRoleClaimPayload = (roleId, formData, menuDetailsData = []) => {
  const permissionIds = new Set();
  const subMenuIds = new Set();

  Object.entries(formData).forEach(([key, value]) => {
    if (!value || !key.startsWith('menu_') || key.includes('enable_all')) return;

    const parts = key.split('_');
    
    // menu_topMenuId_subMenuId_permissionId (4 parts) - this is a permission under a submenu
    if (parts.length === 4) {
      const topMenuId = Number(parts[1]);
      const subMenuId = Number(parts[2]);
      const permissionId = Number(parts[3]);
      
      // Add the actual permission ID
      permissionIds.add(permissionId);
      
      // Add submenu ID only if it's different from the top menu ID
      // (when subMenuId === topMenuId, it means the menu has direct permissions without submenus)
      if (subMenuId !== topMenuId) {
        subMenuIds.add(subMenuId);
      }
    }
  });

  // Handle menus that have direct permissions (hasNotSubMenu = true)
  menuDetailsData.forEach((menu) => {
    if (!menu.hasNotSubMenu) return;

    if (formData[`menu_${menu.id}`]) {
      menu.children?.forEach((perm) => {
        if (perm.isSelected) {
          permissionIds.add(perm.id);
        }
      });
    }
  });

  // Remove any IDs from permissionIds that are actually submenus
  subMenuIds.forEach((subMenuId) => {
    permissionIds.delete(subMenuId);
  });

  return {
    roleId,
    subMenuIds: [...subMenuIds],
    permissionIds: [...permissionIds],
  };
};
